<template>
  <div class="verify-email">
    <RegisterEmail v-if="isDN" />
     <NhstRegistration v-else />
  </div>
</template>

<script>

import RegisterEmail from '@elements/RegisterEmail';
import NhstRegistration from './NhstRegistration.vue';
import { addTrackingEvent } from '@root/src/helpers/Tracking';
import { normalizeToLowerSnakeCase } from '@root/src/helpers/trackingLabels';
export default {
  name: 'nhst-check-username',
  components: { RegisterEmail, NhstRegistration },
  mounted() {
    this.trackStep('Register Email');
  },
  methods: {
    trackStep(verbalName) {
      const identifierValue = normalizeToLowerSnakeCase(verbalName);
      if (!identifierValue) return;
      addTrackingEvent({
        event: 'system_action',
        sub_producer_contract: { name: 'registration', version: '1' },
        attributes: {
          action: 'show',
          identifier_type: 'registration_step',
          identifier_value: identifierValue,
          registration_service: this.$authWebapp.getSource() || '',
          paywall_variation: this.$route.query.paywall_variation_type || '',
          flow_source_url: this.$authWebapp.getTarget('') || '',
        },
      });
    },
  },
};
</script>
